import PropTypes from 'prop-types';

const CountBadge = ({ count, max = 99, className, style, variant = 'secondary' }) => {
    if (!count || count < 0) {
        return null;
    }

    const display = count > max ? `${max}+` : count;

    return <span aria-label={`${count} items`} className={`badge badge-${variant} rounded-circle d-inline-flex align-items-center justify-content-center font-weight-bold ${className || ''}`} style={{ minWidth: '1rem', height: '1rem', padding: '0 0.3rem', fontSize: '0.5rem', lineHeight: 1, boxShadow: '0 0 0 1px white', ...style}}>
        {display}
    </span>;
};

CountBadge.propTypes = {
    count: PropTypes.number,
    className: PropTypes.string,
    max: PropTypes.number,
    style: PropTypes.object,
    variant: PropTypes.string
};

export default CountBadge;
